import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentDealership } from '../../actions/apiSetInfo';
import { change_page } from '../../actions/toggleMenu';
import { deactivateInstallation } from '../../actions/apiDealerUpdates';
import './DealershipLink.scss';

const DeactivateModal = ({ isOpen, onClose, onConfirm, dealershipName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div className="modal-content-dealership" style={{ background: 'white', padding: '20px', borderRadius: '5px', maxWidth: '500px', width: '100%' }}>
        <h3>Deactivate Installation</h3>
        <p>Are you sure you want to deactivate <strong>{dealershipName}</strong>? This action cannot be undone.</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              console.log(`Confirmed deactivation for ${dealershipName}`);
              onConfirm();
            }}
          >
            Deactivate
          </button>
        </div>
      </div>
    </div>
  );
};

const DealershipLink = ({ dealership, showSuperadminSettings }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.current_user);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const selectLocation = () => {
    dispatch(setCurrentDealership(dealership.database, dealership.subdomain, dealership.id));
  };

  const editLocationUsers = () => {
    selectLocation();
    dispatch(change_page('users'));
  };

  const editGroupSettings = () => {
    selectLocation();
    dispatch(change_page('group-settings'));
  };

  const handleDeactivate = () => {
    if (!dealership.id) {
      console.error('Invalid dealership ID');
      return;
    }
    const data = { data: { id: dealership.id } };
    dispatch(deactivateInstallation(dealership.id, data, 'deactivation_error')).then((result) => {
      if (result === 'success') {
        setIsModalOpen(false);
      }
    });
  };

  return (
    <div className="dealership-link-container">
      <div className="dealership-link">
        <div className="dealership-link-info">
          <div className="dealership-link-info-primary">
            <div className="dealership-link-dealer-name">{dealership.softname || 'N/A'}</div>
            <div className="dealership-link-dealer-id">Dealer ID: {dealership.feedprefix || 'N/A'}</div>
          </div>
          <div className="dealership-link-info-secondary">
            <div className="dealership-link-info-secondary-item">{dealership.city || 'N/A'}</div>
            <div className="dealership-link-info-secondary-item">{dealership.state || 'N/A'}</div>
          </div>
        </div>
        <div className="dealership-link-buttons">
          <button onClick={selectLocation}>Select Location</button>
          {(currentUser.position === 'admin' || currentUser.position === 'super_admin') && (
            <button onClick={editLocationUsers}>Edit Users</button>
          )}
          {currentUser.position === 'super_admin' && (
            <>
              <button onClick={editGroupSettings}>({dealership.database})</button>
            </>
          )}
          {currentUser.role === 'superadmin' && showSuperadminSettings && (
            <>
              {!dealership.deactivated_date && (
                <button className="btn-danger" onClick={() => setIsModalOpen(true)}>
                  Deactivate
                </button>
              )}
            </>
          )}
        </div>
      </div>
      {currentUser.role === 'superadmin' && showSuperadminSettings && (
        <DeactivateModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDeactivate}
          dealershipName={dealership.softname || 'this installation'}
        />
      )}
    </div>
  );
};

export default DealershipLink;